export const promisify = (func, funcReq) => {
  return new Promise((resolve, reject) => {
    func(funcReq, (err, svcResp) => {
      if (err) {
        reject(err);
      }
      resolve(svcResp);
    });
  });
};
